(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.trans = this.dataset.trans;
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerWrapper = document.querySelector('.header-wrapper');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();

      window.matchMedia('(max-width: 992px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.onScroll();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if(this.trans != 'none') this.classList.remove('trans_header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if(this.trans != 'none') this.classList.remove('trans_header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        if(this.trans != 'none') this.classList.add('trans_header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
   if(document.getElementsByTagName("sticky-header").length == 0){
    document.documentElement.style.setProperty('--header-height', '0px');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop"] && !Shopify.designMode) return;
  try {
    
class KsShoppableVideos extends HTMLElement {
  constructor () {
    super()
    
    this.slider = null
    this.initializationAttempts = 0
    this.maxAttempts = 10
    
    this.loadSwiperAndInitialize()
    this.setupVideoEvents()
  }

  async loadSwiperAndInitialize() {
    try {
      await this.ensureSwiperLoaded()
      await this.initializeSlider()
    } catch (error) {
      console.error('Failed to initialize Swiper slider:', error)
      // Fallback: show content without slider functionality
      this.showFallbackContent()
    }
  }

  ensureSwiperLoaded() {
    return new Promise((resolve, reject) => {
      // Check if Swiper is already available
      if (window.Swiper) {
        resolve()
        return
      }

      // Check if script is already being loaded
      let existingScript = document.querySelector('#swiper-script')
      
      if (!existingScript) {
        // Create and load the script
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js')
        script.setAttribute('id', 'swiper-script')
        
        script.onload = () => {
          // Wait a bit more for Swiper to be fully available
          setTimeout(() => {
            if (window.Swiper) {
              resolve()
            } else {
              reject(new Error('Swiper not available after loading'))
            }
          }, 100)
        }
        
        script.onerror = () => {
          reject(new Error('Failed to load Swiper script'))
        }
        
        document.head.appendChild(script)
      } else {
        // Script exists, wait for it to load
        this.waitForSwiper(resolve, reject)
      }
    })
  }

  waitForSwiper(resolve, reject) {
    const checkSwiper = () => {
      this.initializationAttempts++
      
      if (window.Swiper) {
        resolve()
      } else if (this.initializationAttempts >= this.maxAttempts) {
        reject(new Error('Swiper loading timeout'))
      } else {
        setTimeout(checkSwiper, 200)
      }
    }
    
    checkSwiper()
  }

  async initializeSlider() {
    const swiperElement = this.querySelector('.swiper')
    if (!swiperElement) {
      throw new Error('Swiper element not found')
    }

    // Initialize Swiper
    this.slider = new window.Swiper(swiperElement, this.splideOptions())

    // Setup event listeners
    this.slider.on('slideChange', () => {
      swiperElement.classList.add('swiper-is-changing')
      this.onSlideChange()
    })

    this.slider.on('slideChangeTransitionEnd', () => {
      swiperElement.classList.remove('swiper-is-changing')
    })

    // Mark as initialized
    swiperElement.classList.add('swiper-initialized')
  }

  showFallbackContent() {
    // Show the slider content even if Swiper fails to load
    const swiperElement = this.querySelector('.swiper')
    if (swiperElement) {
      swiperElement.style.opacity = '1'
      swiperElement.classList.add('swiper-fallback')
      
      // Hide navigation elements since they won't work
      const nav = this.querySelectorAll('.swiper-button-prev, .swiper-button-next, .swiper-pagination, .swiper-scrollbar')
      nav.forEach(el => el.style.display = 'none')
    }
  }

  setupVideoEvents() {
    this.querySelectorAll('.ks-shoppable-videos-btn-play').forEach(btn => {
      btn.addEventListener('click', () => {
        const video = btn.closest('.ks-shoppable-videos-video-wrapper').querySelector('video')
        this.onVideoPlay(video)
      })
    })
    
    this.querySelectorAll('video').forEach(video => {
      video.addEventListener('click', () => {
        this.onVideoPlay(video)
      })
    })
  }

  splideOptions() {
    const partialSlidesMobile = this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1

    return {
      rewind: true,
      speed: Number(this.dataset.sliderSpeed),
      breakpoints: {
        0: { slidesPerView: Number(this.dataset.breakpointXs) * partialSlidesMobile },
        576: { slidesPerView: Number(this.dataset.breakpointSm) },
        768: { slidesPerView: Number(this.dataset.breakpointMd) },
        992: { slidesPerView: Number(this.dataset.breakpointLg) },
        1200: { slidesPerView: Number(this.dataset.breakpointXl) },
        1400: { slidesPerView: Number(this.dataset.breakpointXxl) }
      },
      navigation: {
        enabled: this.dataset.sliderNav === 'true',
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      pagination: {
        enabled: this.dataset.sliderPagination === 'true',
        type: this.dataset.sliderPaginationType,
        el: '.swiper-pagination',
        dynamicBullets: true,
        dynamicMainBullets: 2,
        renderFraction: function (currentClass, totalClass) {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
        }
      },
      scrollbar: {
        enabled: this.dataset.sliderScrollbar === 'true',
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true
      },
      autoplay: this.dataset.sliderAutoplay !== '0'
        ? { delay: Number(this.dataset.sliderAutoplay) * 1000 }
        : undefined,
      watchSlidesProgress: true,
      mousewheel: {
        enabled: true,
        forceToAxis: true
      }
    }
  }

  onSlideChange() {
    this.querySelectorAll('.ks-shoppable-videos-card').forEach(elem => {
      elem.setAttribute('data-is-playing', 'false')
      elem.querySelector('video')?.pause()
    })
  }

  onVideoPlay(video) {
    const card = video.closest('.ks-shoppable-videos-card')

    this.querySelectorAll('.ks-shoppable-videos-card').forEach(elem => {
      if (elem.dataset.index !== card.dataset.index) {
        elem.setAttribute('data-is-playing', 'false')
        elem.querySelector('video')?.pause()
      }
    })
    
    if (card.dataset.isPlaying === 'true') {
      card.setAttribute('data-is-playing', 'false')
      video.pause()
    } else {
      card.setAttribute('data-is-playing', 'true')
      video.muted = false
      video.play()
    }
  }
}

customElements.define('ks-shoppable-videos', KsShoppableVideos)

  } catch(e) { console.error(e); }
})();
})();
